import upload_pic from '../img/icon/image-upload-fill.png';
import delete_pic from '../img/icon/close-circle-line.svg';

const UploadFile = ({ title, file, filetype, handleFileChange, setFileEmpty }) => {
    return (
        <>     
            <label class="custom-file-upload">{title}</label>
            <div class="file-upload-div">
                <i class="fa fa-cloud-upload"></i> 
                <label for="pic" alt="Button für Profilbild-Upload">
                    <div class="pic-upload-src-div">
                        <img src={upload_pic}/>
                    </div>
                </label>
                <input
                    id="pic"
                    name="pic"
                    type="file"
                    inputProps={{ accept: 'image/*'}}
                    
                    label="Document"
                    onChange={e => handleFileChange(e)}
                    size="small"
                    variant="standard"
                />
            </div>
            <div className="uploaded-pic-div">
                <div className="photo-container">
                    {file && <img src={file} id="uploaded-pic" alt="file preview"/>}
                </div>
                <div className="uploaded-pic-delete-container" onClick={e => setFileEmpty(e)}>
                    {file && <img src={delete_pic} id="delete_upload_pic_btn"/>}
                </div>
            </div>

        </>
   );
};


export default UploadFile